// extracted by mini-css-extract-plugin
export default {"root":"bCkpO","title":"R4dOl","sticker":"uCPxZ","selected":"ZISbs","iconWrapper":"K5PJf","icon":"XxIiz","content":"lrbgf","label":"ofz21","value":"D9ASX"};